<template>
  <div class="page-wrap" id="f-book-now">

    <!-- Full-screen saving overlay -->
    <transition name="fade">
      <div class="processing-overlay" v-if="saveDataLoader">
        <div class="processing-card">
          <i class="fa fa-circle-o-notch fa-spin"></i>
          <div class="processing-title" v-html="loadingMessage"></div>
        </div>
      </div>
    </transition>

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-id-card"></i></div>
          <div>
            <div class="panel-title">Additional Service</div>
            <div class="panel-sub">Appointment #{{ $route.params.app_id }}</div>
          </div>
        </div>
        <button class="btn-back" @click="goback">
          <i class="fa fa-arrow-left"></i> Go Back
        </button>
      </div>

      <!-- Error alert -->
      <div class="error-strip" v-if="errorMsg">
        <i class="fa fa-exclamation-circle"></i>
        <span>{{ errorMsg }}</span>
      </div>

      <!-- Section labels -->
      <div class="section-grid">
        <div class="section-label">
          <i class="fa fa-receipt"></i> Service Summary
        </div>
        <div class="section-label">
          <i class="fa fa-credit-card"></i> Payment
        </div>
      </div>

      <!-- Payment form -->
      <div class="payment-wrap">
        <f-payment :front_status="false" :is_both_card="false"></f-payment>
      </div>

    </div>

    <!-- Floating save bar -->
    <div class="save-bar">
      <div class="save-bar-total">
        <span class="sbt-label">Total</span>
        <span class="sbt-amount">${{ getTotalAdditionalAmount | toFixedTwoDigit }}</span>
      </div>
      <div class="save-bar-actions">
        <button class="btn-cancel" @click="goback">
          <i class="fa fa-times"></i> Back
        </button>
        <button class="btn-submit" @click="SubmitService">
          <i class="fa fa-check"></i> Submit
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import fPayment from "@/pages/frontend/booknow/payment.vue";

import { mapGetters } from "vuex";
import {
  FETCH_NOTES,
  STORE_ADDITIONAL_SERVICE,
  CHECK_F_ABBREVIATION_CODE,
  FETCH_F_CLIENT_RATE,
  FETCH_COUNTRIES,
  FETCH_STATES,
} from "@/core/services/store/actions.type";
import {
  SET_F_CLIENT_ENABLE_ON_SITE_PAYMENT,
  SET_PAYMENT_CARD_PROPERTY,
  SET_PAYMENT_CARD_TYPE,
  SET_PAYMENT_CARD_NUMBER,
  SET_PAYMENT_CARD_HOLDER_NAME,
  SET_PAYMENT_CARD_ADDRESS,
  SET_PAYMENT_CARD_CITY,
  SET_PAYMENT_CARD_CVV_NUMBER,
  SET_PAYMENT_CARD_EXPIRY_DATE,
  CARD_COUNTRY,
  CARD_STATE,
  SET_PAYMENT_CARD_NUMBER_PHONE,
  SET_PAYMENT_CARD_NUMBER_POSTAL,
  SET_RATE_TOTAL_AMOUNT,
  UPDATE_ABBREVIATION_CODE,
  UPDATE_PAYMENT_TYPE,
  SET_ADD_RATE_QTY
} from "@/core/services/store/mutations.type";

export default {
  components: {
    fPayment
  },
  computed: {
    ...mapGetters([
      "getServiceId",
      "getAddQty",
      "getfClientRate",
      "getTotalRateAmount",
      "getAbbreviationCode",
      "updateAbbreviationCode",
      "getPaymentCardHolderName",
      "getPaymentCardExpiry",
      "getPaymentCardCvvNumber",
      "getPaymentCardType",
      "getPaymentCardHolderAddress",
      "getPaymentCardHolderCountry",
      "getPaymentCardHolderState",
      "getPaymentCardHolderCity",
      "getPaymentCardPhonecode",
      "getPaymentCardPhone",
      "getPaymentCardPostalZip",
      "getPaymentType",
      "getIsHeartsPayment",
      "getTotalAdditionalAmount"
    ])
  },
  mounted() {
    if (this.getServiceId == 0 && this.getServiceId != this.$route.params.id) {
      this.$router.go(-1);
    }
    this.$store.commit(
      SET_F_CLIENT_ENABLE_ON_SITE_PAYMENT,
      this.$route.params.onsite
    );
    this.$store.dispatch(FETCH_NOTES);
    if (this.getServiceId != "") {
      this.fetchRate();
      if (this.updateAbbreviationCode != "") {
        this.abree_code = this.updateAbbreviationCode;
        this.checkAbbreviationCode();
      }
    }
    this.$store.commit(SET_ADD_RATE_QTY, 0);
    this.$store.commit(SET_PAYMENT_CARD_PROPERTY, "");
    this.$store.commit(SET_PAYMENT_CARD_TYPE, "");
    this.$store.commit(SET_PAYMENT_CARD_NUMBER, "");
    this.$store.commit(SET_PAYMENT_CARD_HOLDER_NAME, "");
    this.$store.commit(SET_PAYMENT_CARD_ADDRESS, "");
    this.$store.commit(SET_PAYMENT_CARD_CITY, "");
    this.$store.commit(SET_PAYMENT_CARD_CVV_NUMBER, "");
    this.$store.commit(SET_PAYMENT_CARD_EXPIRY_DATE, "");
    this.$store.commit(CARD_COUNTRY, "US");
    this.$store.commit(CARD_STATE, "");
    this.$store.commit(SET_PAYMENT_CARD_NUMBER_PHONE, "");
    this.$store.commit(SET_PAYMENT_CARD_NUMBER_POSTAL, "");
    this.$store.dispatch(FETCH_COUNTRIES);
    this.$store.dispatch(FETCH_STATES);
  },
  data() {
    return {
      errorMsg: "",
      dataLoading: false,
      loadingMessage: "",
      saveDataLoader: false
    };
  },
  filters: {
    toFixedTwoDigit(amount) {
      return parseFloat(amount).toFixed(2);
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    fetchRate() {
      this.loadingData = true;
      var id = this.$route.params.id;
      var service_id = this.getServiceId;

      this.$store
        .dispatch(FETCH_F_CLIENT_RATE, {
          id: id,
          service_id: service_id
        })
        .then(data => {
          this.rateData = data;
          this.loadingData = false;
          var add_rate = parseFloat(this.getfClientRate.additional_rate);
          var tax_percentage = parseFloat(this.getfClientRate.tax_percentage);

          this.$store.commit(
            SET_RATE_TOTAL_AMOUNT,
            (1 * add_rate + (1 * add_rate * tax_percentage) / 100).toFixed(2)
          );
        })
        .catch(() => {
          this.loadingData = false;
        });
    },
    checkAbbreviationCode() {
      this.$store.commit(UPDATE_ABBREVIATION_CODE, this.abree_code);
      if (this.updateAbbreviationCode != "") {
        this.abbreviation_code_error = true;

        this.$store
          .dispatch(CHECK_F_ABBREVIATION_CODE, {
            code: this.updateAbbreviationCode,
            client_slug: this.$route.params.client_slug
          })
          .then(data => {
            if (data.success) {
              this.paymentMethod = data.data.show_payment_option;
              if (!data.data.show_payment_option) {
                this.$store.commit(UPDATE_PAYMENT_TYPE, "A");
              }
              this.abree_code = "";
            } else {
              this.paymentMethod = true;
            }
          });
      } else {
        this.abbreviation_code_error = false;
      }
    },
    SubmitService() {
      var mytoken = document.getElementById("mytoken");

      mytoken = mytoken.innerHTML;
      if (this.updateAbbreviationCode != "") {
        if (!this.getAbbreviationCode.success) {
          this.$toastr.e(this.getAbbreviationCode.msg);
        } else {
          if (this.getPaymentType == "C") {
            this.loadingMessage =
              "please wait <br> While we process your payment...";

            if (mytoken == "" || mytoken == null) {
              this.$toastr.e(
                "The card number entered is not compliant, please check and re-enter."
              );
            } else {
              if (this.getIsHeartsPayment) {
                var expiremonth = document.getElementById("expiremonth")
                  .innerHTML;
                var expireyear = document.getElementById("expireyear")
                  .innerHTML;

                if (
                  mytoken == "" ||
                  mytoken == null ||
                  expiremonth == "" ||
                  expiremonth == null ||
                  expireyear == "" ||
                  expireyear == null
                ) {
                  this.$toastr.e("Card info is required");
                } else {
                  this.SubmitForm();
                }
              } else {
                if (
                  mytoken == "" ||
                  mytoken == null ||
                  this.getPaymentCardHolderName == "" ||
                  this.getPaymentCardExpiry == "" ||
                  this.getPaymentCardCvvNumber == ""
                ) {
                  this.$toastr.e("Card info is required");
                } else {
                  this.SubmitForm();
                }
              }
            }
          } else {
            this.loadingMessage =
              "please wait <br> Your appointment is being scheduled...";

            this.SubmitForm();
          }
        }
      } else {
        if (this.getPaymentType == "C") {
          this.loadingMessage =
            "please wait <br> While we process your payment...";
          if (mytoken == "" || mytoken == null) {
            this.$toastr.e(
              "The card number entered is not compliant, please check and re-enter."
            );
          } else {
            if (this.getIsHeartsPayment) {
              var expiremonth2 = document.getElementById("expiremonth")
                .innerHTML;
              var expireyear2 = document.getElementById("expireyear").innerHTML;

              if (
                mytoken == "" ||
                mytoken == null ||
                expiremonth2 == "" ||
                expiremonth2 == null ||
                expireyear2 == "" ||
                expireyear2 == null
              ) {
                this.$toastr.e("Card info is required");
              } else {
                this.SubmitForm();
              }
            } else {
              if (
                mytoken == "" ||
                mytoken == null ||
                this.getPaymentCardHolderName == "" ||
                this.getPaymentCardExpiry == "" ||
                this.getPaymentCardCvvNumber == ""
              ) {
                this.$toastr.e("Card info is required");
              } else {
                this.SubmitForm();
              }
            }
          }
        } else {
          this.loadingMessage =
            "please wait <br> Your appointment is being scheduled...";
          this.SubmitForm();
        }
      }
    },
    SubmitForm() {
      this.errorMsg = "";
      let updateAbbreviationCode = "";
      if (this.getAbbreviationCode.data.length == 0) {
        updateAbbreviationCode = "";
      } else {
        updateAbbreviationCode = this.updateAbbreviationCode;
      }
      this.saveDataLoader = true;
      var mytoken = document.getElementById("mytoken");
      var formData = {
        type: this.getPaymentType,
        appointment_id: this.$route.params.app_id,
        abbreviation_code: updateAbbreviationCode,
        sms_status: false,
        appt_token: this.$route.params.token,
        qty: this.getAddQty
      };
      if (this.getAddQty == 0) {
        this.$toastr.w("Please add atleast one card");
        this.saveDataLoader = false;
        return;
      }

      let token = mytoken.innerHTML;
      if (this.getPaymentType == "C") {
        if (this.getIsHeartsPayment) {
          var expiremonth = document.getElementById("expiremonth");
          var expireyear = document.getElementById("expireyear");
          var token_type = document.getElementById("token_type");
          var last_four = document.getElementById("last_four");
          var card_type = document.getElementById("card_type");
          formData.payment_details = {
            hearts_token: token,
            expire_month: expiremonth.innerHTML,
            expire_year: expireyear.innerHTML,
            postal: this.getPaymentCardPostalZip,
            token_type: token_type.innerHTML,
            last_four: last_four.innerHTML,
            card_type: card_type.innerHTML,
            card_address: this.getPaymentCardHolderAddress
          };
        } else {
          formData.payment_details = {
            card_number: token,
            card_holder_name: this.getPaymentCardHolderName,
            card_expiry: this.getPaymentCardExpiry,
            card_cvv_no: this.getPaymentCardCvvNumber,
            card_type: this.getPaymentCardType,
            card_address: this.getPaymentCardHolderAddress,
            card_city: this.getPaymentCardHolderCity,
            card_country: this.getPaymentCardHolderCountry,
            card_state: this.getPaymentCardHolderState,
            phone:
              this.getPaymentCardPhonecode.dial_code + this.getPaymentCardPhone,
            postal: this.getPaymentCardPostalZip
          };
        }
      }

      this.$store
        .dispatch(STORE_ADDITIONAL_SERVICE, {
          formData
        })
        .then(res => {
          if (res.code == 200) {
            this.$toastr.s(res.msg);
            this.$router.go(-1);
          }
          this.saveDataLoader = false;
        })
        .catch(errs => {
          if (errs.msg == "") {
            this.$toastr.e("oops something went wrong");
            return;
          }
          this.$toastr.e(errs.msg);
          this.errorMsg = errs.msg;
          this.saveDataLoader = false;
        });
    },
    storeAdditionalService() {
      let data = {
        appointment_id: this.$route.params.app_id,
        qty: this.getAddQty,
        appt_token: this.$route.params.token
      };
      this.$store
        .dispatch(STORE_ADDITIONAL_SERVICE, {
          data
        })
        .then(res => {
          if (res.code == 200) {
            this.$toastr.s(res.msg);
            this.$router.go(-1);
          }
        })
        .catch(errs => {
          this.$toastr.e("oops something went wrong");
          this.errorMsg = errs.msg;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$green:  #276749;
$border: #dde2ec;

.page-wrap {
  padding: 8px 0 100px;
  font-family: $font;
}

/* ── Processing overlay ── */
.processing-overlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  background: rgba(13,27,62,0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.processing-card {
  background: #fff;
  border-radius: 14px;
  padding: 32px 40px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(13,27,62,0.18);

  i {
    font-size: 28px;
    color: $blue;
    margin-bottom: 12px;
    display: block;
  }
}

.processing-title {
  font-size: 13px;
  color: $dark;
  font-family: $font;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter, .fade-leave-to           { opacity: 0; }

/* ── Panel ── */
.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13,27,62,0.07);
  overflow: hidden;
}

/* ── Header ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #fafbfd;
  border-bottom: 1px solid #eef0f6;
  gap: 12px;
  flex-wrap: wrap;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: $blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: $dark;
}

.panel-sub {
  font-size: 11px;
  color: #8a94a6;
  margin-top: 2px;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  background: #fff;
  color: #4a5568;
  border: 1.5px solid $border;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: all 0.15s;

  &:hover { border-color: $blue; color: $blue; }
}

/* ── Error strip ── */
.error-strip {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 16px 20px 0;
  padding: 12px 16px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  color: #b91c1c;
  font-size: 13px;
  font-weight: 500;

  i {
    font-size: 14px;
    margin-top: 1px;
    flex-shrink: 0;
  }
}

/* ── Section label bar ── */
.section-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid #eef0f6;
}

.section-label {
  padding: 9px 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8a94a6;
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f8f9fc;
  border-right: 1px solid #eef0f6;

  &:last-child { border-right: none; }

  i { color: $blue; font-size: 12px; }
}

/* ── Payment wrap ── */
.payment-wrap {
  padding: 20px;
}

/* ── Floating save bar ── */
.save-bar {
  position: fixed;
  bottom: 2.5rem;
  width: calc(78vw);
  background: #1a2340;
  border-radius: 12px;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  box-shadow: 0 8px 32px rgba(13,27,62,0.28);
  z-index: 100;
  flex-wrap: wrap;
}

.save-bar-total {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.sbt-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8fa3c8;
}

.sbt-amount {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  font-family: $font;
}

.save-bar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-cancel {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 18px;
  background: transparent;
  color: #a0b3d6;
  border: 1.5px solid #3a4d6e;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: all 0.15s;

  &:hover { border-color: #e53e3e; color: #e53e3e; }
}

.btn-submit {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 36px;
  padding: 0 22px;
  background: $green;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover { opacity: 0.9; }
}
</style>

<style lang="scss">
/* ── fPayment overrides scoped to this page via #f-book-now ── */
$font:  'Segoe UI', sans-serif;
$blue:  #389ad4;
$dark:  #0d1b3e;
$green: #276749;

#f-book-now {

  #f-payement {
    font-family: $font;

    /* ── Rate / summary tables ── */
    .table-bg-success {
      background: #fff !important;
      border-radius: 10px;
      overflow: hidden;
      border: 1px solid #e8edf5;
      font-size: 13px;

      thead tr th {
        background: #f5f8fe;
        color: #6b7a9b;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        border-bottom: 1px solid #e8edf5;
        padding: 9px 12px;
      }

      tbody tr td,
      tbody tr th {
        padding: 10px 12px;
        border-bottom: 1px solid #f0f3f9;
        color: $dark;
        font-size: 13px;
        vertical-align: middle;
      }

      tbody tr:last-child td,
      tbody tr:last-child th {
        border-bottom: none;
      }
    }

    /* ── Section headings ── */
    h4 {
      font-size: 13px;
      font-weight: 700;
      color: $dark;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    /* ── Additional cards qty control ── */
    h4 .fa-minus,
    h4 .fa-plus {
      width: 24px;
      height: 24px;
      border-radius: 6px;
      background: #f0f4ff;
      border: 1.5px solid #d0daf7;
      color: $blue;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      transition: background 0.15s, border-color 0.15s;

      &:hover {
        background: $blue;
        color: #fff;
        border-color: $blue;
      }
    }

    h4 span[style*="border"] {
      border: 1.5px solid #dde2ec !important;
      border-radius: 6px !important;
      padding: 2px 14px !important;
      font-size: 13px;
      font-weight: 700;
      color: $dark;
      min-width: 36px;
      text-align: center;
      display: inline-block;
    }

    /* ── Abbreviation / promo / ORI inputs ── */
    .abbre-code,
    .promo-code {
      align-items: center;
      gap: 12px;
      margin-bottom: 12px;

      label {
        font-size: 12px;
        font-weight: 600;
        color: #6b7a9b;
        line-height: normal !important;
        width: auto !important;
        white-space: nowrap;
      }

      .input-group {
        margin-bottom: 0 !important;
        flex: 1;

        input.form-control {
          border: 1.5px solid #dde2ec;
          border-radius: 8px 0 0 8px;
          font-size: 13px;
          height: 36px;
          color: $dark;
          padding: 0 12px;

          &:focus {
            border-color: $blue;
            box-shadow: 0 0 0 3px rgba(56,154,212,0.1);
            outline: none;
          }
        }

        .input-group-append .btn-success {
          background: $green;
          border-color: $green;
          border-radius: 0 8px 8px 0;
          height: 36px;
          padding: 0 16px;
          font-size: 12px;
          font-weight: 600;
          font-family: $font;
        }
      }
    }

    /* ── Abbreviation code confirmed state ── */
    strong.text-uppercase { color: $blue; }

    .btn-danger {
      border-radius: 8px;
      font-size: 12px;
      font-weight: 600;
      padding: 6px 14px;
      font-family: $font;
    }

    /* ── Payment section headings ── */
    h5 {
      font-size: 13px;
      font-weight: 700;
      color: $dark;
    }

    /* ── Payment type list ── */
    .payment-type {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        background: #fafbfd !important;
        border: 1.5px solid #e8edf5;
        border-radius: 10px;
        padding: 14px !important;
        margin-bottom: 10px;
        cursor: default;

        &:hover { background: #f5f8fe !important; }

        &.active {
          border-color: $blue !important;
          background: #f0f7ff !important;
        }

        .checked-payment {
          display: none !important;
        }

        label {
          margin: 0;
          span {
            font-size: 13px;
            font-weight: 600;
            color: $dark;
          }
        }
      }
    }

    /* ── Card form fields ── */
    .paymemt-label {
      font-size: 11px !important;
      font-weight: 700 !important;
      color: #6b7a9b !important;
      text-transform: uppercase;
      letter-spacing: 0.3px;
      margin-bottom: 4px !important;
    }

    .form-control {
      border: 1.5px solid #dde2ec;
      border-radius: 8px;
      font-size: 13px;
      height: 38px;
      color: $dark;
      font-family: $font;

      &:focus {
        border-color: $blue;
        box-shadow: 0 0 0 3px rgba(56,154,212,0.1);
        outline: none;
      }
    }

    /* ── Card payment info container ── */
    #payment-info {
      display: block !important;
    }

    div[style*="background: #eef0f8"],
    div[style*="background: #eef0f8;"] {
      background: #f5f8fe !important;
      border-radius: 10px;
      padding: 14px !important;
      border: 1px solid #e8edf5;
    }

    /* Billing address subheading */
    div[style*="background: #eef0f8"] .d-flex label {
      font-size: 12px;
      font-weight: 700;
      color: $dark;
    }

    /* ── On-site payment checkbox ── */
    .form-group[style*="inline-flex"] {
      align-items: center;
      padding: 10px 0 4px;

      label {
        font-size: 12.5px;
        color: $dark;
        margin-top: 0 !important;
      }
    }

    /* ── Supported cards row ── */
    .d-flex > label[style*="60%"] {
      font-size: 12px;
      font-weight: 600;
      color: $dark;
    }

    hr {
      border-color: #eef0f6;
      margin: 12px 0;
    }
  }
}
</style>
